<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="ESOP物料绑定"
      width="1000px"
      top="5vh"
      @close="tableData = []">
    <el-table
        v-loading="contentLoading"
        :data="tableData"
        border>
      <el-table-column type="index" label="序号" align="center" width="40"/>
      <el-table-column prop="materialNo" label="物料号" align="center" width="110"/>
      <el-table-column prop="materialName" label="物料描述" show-overflow-tooltip/>
      <el-table-column prop="createTime" label="绑定时间" align="center" width="135"/>
      <el-table-column label="操作" align="center" width="80">
        <template #header>
          <el-button type="text" @click="$refs.materialSelect.open()">+ 新增</el-button>
        </template>
        <template v-slot="scope">
          <el-button type="danger" @click="handleDelete(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
    <material-select ref="materialSelect" @select="handleMaterialSelect"/>
  </el-dialog>
</template>

<script>

  import MaterialSelect from "@/views/information/Material/MaterialSelect.vue";

  export default {
    name: "EsopMaterialList",
    components: {MaterialSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        model: {
          esopId: "",
          materialIds: [],
        },
      };
    },
    methods: {
      open(row) {
        this.model.esopId = row.id;
        if (this.model.esopId) {
          this.getData();
        } else {
          this.$message.error("未读取到文件id");
        }
        this.dialogVisible = true;
      },
      getData() {
        this.contentLoading = true;
        this.$http.get("basic", `esops/detail/${this.model.esopId}`)
          .then(res => {
            this.tableData = res ? res.esopMaterials : [];
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      handleMaterialSelect(row) {
        if (this.tableData.some(item => item.materialId === row.id)) {
          return;
        }
        let item = {
          materialId: row.id,
          materialNo: row.no,
          materialName: row.name,
        };
        this.tableData.push(item);
      },
      handleDelete(index) {
        this.tableData.splice(index, 1);
      },
      handleSubmit() {
        this.model.materialIds = this.tableData.map(item => item.materialId);
        this.$http.post("basic", `esops/material/${this.model.esopId}`, this.model.materialIds)
          .then(() => {
            this.$message.success("保存成功");
            this.$emit("save-success");
            this.dialogVisible = false;
          })
          .catch(err => {
            this.$message.error("保存失败：" + err);
          });
      },
    },
  };
</script>

<style lang="scss">

</style>
